import Text from '@/components/react-native/text';
import TouchableOpacity from '@/components/react-native/touchable-opacity';
import View from '@/components/react-native/view';
import React from 'react';

interface AirportInfoEditModalProps {
  visible: boolean;
  editedInfo: {
    effective: string;
    version: string;
    published: string;
    country: string;
  };
  onInfoChange: (field: string, value: string) => void;
  onSave: () => void;
  onClose: () => void;
}

export const AirportInfoEditModal: React.FC<AirportInfoEditModalProps> = ({
  visible,
  editedInfo,
  onInfoChange,
  onSave,
  onClose
}) => {
  if (!visible) return null;

  const handleSave = () => {
    onSave();
    onClose();
  };

  return (
    <>
      <style>
        {`
          input[type="date"]::-webkit-calendar-picker-indicator {
            filter: invert(1);
            cursor: pointer;
          }
          input[type="date"]::-webkit-datetime-edit {
            color: #FAFAF9;
          }
          input[type="date"]::-webkit-datetime-edit-text {
            color: #FAFAF9;
          }
          input[type="date"]::-webkit-datetime-edit-month-field {
            color: #FAFAF9;
          }
          input[type="date"]::-webkit-datetime-edit-day-field {
            color: #FAFAF9;
          }
          input[type="date"]::-webkit-datetime-edit-year-field {
            color: #FAFAF9;
          }
        `}
      </style>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <View className="bg-[#1C1C1E] rounded-[8px] p-[24px] w-[480px] max-w-[90vw]">
          {/* Modal Header */}
          <View className="flex-row items-center justify-between mb-[24px]">
            <Text
              fontFamily="Geist"
              className="text-[#FAFAF9] text-[18px] font-[600] tracking-[-0.36px]"
            >
              Edit Airport Information
            </Text>
            <TouchableOpacity className="p-[8px]" onClick={onClose}>
              <Text className="text-[#78716C] text-[20px] font-bold">×</Text>
            </TouchableOpacity>
          </View>

          {/* Form Fields */}
          <View className="space-y-[16px] mb-[24px]">
            {/* Country Field */}
            <View>
              <Text
                fontFamily="Geist"
                className="text-[#FAFAF9] text-[14px] font-[500] mb-[8px]"
              >
                Country
              </Text>
              <input
                type="text"
                value={editedInfo.country}
                onChange={(e) => onInfoChange('country', e.target.value)}
                className="w-full bg-[#2C2C2E] border border-[#38BDF8] rounded-[4px] px-[12px] py-[12px] text-[#FAFAF9] text-[16px] font-[400] focus:outline-none focus:border-[#60A5FA]"
                placeholder="Enter country"
              />
            </View>

            {/* Effective Date Field */}
            <View>
              <Text
                fontFamily="Geist"
                className="text-[#FAFAF9] text-[14px] font-[500] mb-[8px]"
              >
                Effective Date
              </Text>
              <input
                type="date"
                value={editedInfo.effective}
                onChange={(e) => onInfoChange('effective', e.target.value)}
                className="w-full bg-[#2C2C2E] border border-[#38BDF8] rounded-[4px] px-[12px] py-[12px] text-[#FAFAF9] text-[16px] font-[400] focus:outline-none focus:border-[#60A5FA]"
              />
            </View>

            {/* Version Field */}
            <View>
              <Text
                fontFamily="Geist"
                className="text-[#FAFAF9] text-[14px] font-[500] mb-[8px]"
              >
                Version
              </Text>
              <input
                type="text"
                value={editedInfo.version}
                onChange={(e) => onInfoChange('version', e.target.value)}
                className="w-full bg-[#2C2C2E] border border-[#38BDF8] rounded-[4px] px-[12px] py-[12px] text-[#FAFAF9] text-[16px] font-[400] focus:outline-none focus:border-[#60A5FA]"
                placeholder="Enter version"
              />
            </View>

            {/* Published Date Field */}
            <View>
              <Text
                fontFamily="Geist"
                className="text-[#FAFAF9] text-[14px] font-[500] mb-[8px]"
              >
                Published Date
              </Text>
              <input
                type="date"
                value={editedInfo.published}
                onChange={(e) => onInfoChange('published', e.target.value)}
                className="w-full bg-[#2C2C2E] border border-[#38BDF8] rounded-[4px] px-[12px] py-[12px] text-[#FAFAF9] text-[16px] font-[400] focus:outline-none focus:border-[#60A5FA]"
              />
            </View>
          </View>

          {/* Action Buttons */}
          <View className="flex-row items-center justify-end gap-[12px]">
            <TouchableOpacity
              className="px-[20px] py-[12px] bg-[rgba(120,113,108,0.1)] border border-[#78716C] rounded-[4px]"
              onClick={onClose}
            >
              <Text
                fontFamily="Geist"
                className="text-[#78716C] text-[14px] font-[500] tracking-[-0.28px]"
              >
                Cancel
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              className="px-[20px] py-[12px] bg-[rgba(34,197,94,0.1)] border border-[#22C55E] rounded-[4px]"
              onClick={handleSave}
            >
              <Text
                fontFamily="Geist"
                className="text-[#22C55E] text-[14px] font-[500] tracking-[-0.28px]"
              >
                Save Changes
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </div>
    </>
  );
};
